import React from 'react';

import { ConditionsShape } from 'next/entities/rules';

import ChecklistCondition from './ChecklistCondition';
import FlowCondition from './FlowCondition';
import LanguageCondition from './LanguageCondition';
import SegmentCondition from './SegmentCondition';
import { DomainCondition } from './DomainCondition';
import { EventCondition } from './EventCondition';
import { GroupCondition } from './GroupCondition';
import { PropertyCondition } from './PropertyCondition';
import { UrlCondition } from './UrlCondition';
import { VersionCondition } from './VersionCondition';

const SUB_CONDITIONS = {
  checklists: ChecklistCondition,
  content: FlowCondition,
  domains: DomainCondition,
  event: EventCondition,
  groups: GroupCondition,
  languages: LanguageCondition,
  properties: PropertyCondition,
  segments: SegmentCondition,
  url: UrlCondition,
  version: VersionCondition,
};

export const ReadableConditions = ({ conditions }) => {
  const [[type, subConditions]] = Object.entries(conditions);

  if (['and', 'or'].includes(type)) {
    return conditions[type].flatMap((clause, c) => [
      <ReadableConditions key={c} conditions={clause} />,
      ...(c < subConditions.length - 1 ? ` ${type} ` : []),
    ]);
  }

  if (type === 'not') {
    const [[subConditionType, negatedCondition]] = Object.entries(
      subConditions[0]
    );

    const SubCondition = SUB_CONDITIONS[subConditionType];

    // eslint-disable-next-line @appcues/jsx-props-no-spreading
    return <SubCondition negated {...negatedCondition} />;
  }

  const SubCondition = SUB_CONDITIONS[type];

  // eslint-disable-next-line @appcues/jsx-props-no-spreading
  return <SubCondition {...subConditions} />;
};

ReadableConditions.propTypes = {
  conditions: ConditionsShape,
};

export default ReadableConditions;
